module.exports = __webpack_public_path__ + "static/media/php.26c4fb11.svg";